import type { WorkspaceBundle } from '@adminhub/graphql-types';

import type { TupleUnion } from './common';

export enum EnterpriseCollectionPackageType {
  EnterpriseTeamworkCollection = 'enterprise-teamwork-collection',
}

export interface CollectionConfig {
  /**
   * See https://workbench.staging.atl-paas.net/products?categoriesIn=CLOUD&billingSystem=CCP&productOwner=Atlassian
   *
   * Returns the `productId` that is used by CCP and `admin-portfolio` services.
   */
  readonly productId: string;

  readonly type: WorkspaceBundle;

  readonly enterpriseCollectionPackageType?: EnterpriseCollectionPackageType;

  readonly offersEnterpriseApps?: boolean;

  readonly childProductIds?: string[];
}

export interface CollectionOfferingEnterpriseApps extends CollectionConfig {
  readonly enterpriseCollectionPackageType: EnterpriseCollectionPackageType;
  readonly offersEnterpriseApps: boolean;
  readonly childProductIds: string[];
}

export interface CollectionConfigInputOptions {
  productId: string;
}

/**
 * The priority of which the keys from {@link CollectionConfigInputOptions} should be used when creating a {@link CollectionConfig}.
 */
export const CollectionConfigInputOptionPriority: TupleUnion<keyof CollectionConfigInputOptions> = ['productId'];
